<template>
  <div>
    <div class="section" :class="$mq">
      <div class="title">{{ $t("step2.consumption.title") }}</div>
      <SwitchField
        id="knowConsumption"
        name="knowConsumption"
        v-model="knowConsumption"
        :options="[$t(`step2.consumption.yes`),$t(`step2.consumption.no`) ]"
        :default="knowConsumption" />
      <button v-if="!knowConsumption" class="button average" :class="{TA:isTestAchat}" @click="average()">{{ $t('step2.consumption.useAverage') }}</button>

      <SwitchField
        style="padding: 10px 0"
        v-if="knowConsumption && solarPanelsScenario === 'COMM_OFFTAKE_AND_INJECTION'"
        id="knowNetConsumption"
        name="knowNetConsumption"
        v-model="knowNetConsumption"
        :maxWidth="true"
        :options="[$t(`step2.consumption.knownNetConsumption.label`), $t(`step2.consumption.unknownNetConsumption.label`)]"
        :default="knowNetConsumption"
      />

      <div class="container inline top margin-top" v-if="knowConsumption">
        <label
          :for="`index-${item.meterType}`"
          v-for="(item, i) in activeConsumptions"
          :key="i"
        >
          <h4>{{ getMeterTypeLabel(item) }}</h4>
          <ValidationProvider
            rules="required|numeric"
            v-slot="{ errors }"
            :customMessages="{ required: $t('step2.consumption.required') }"
          >
          <div :class="{error: errors.length}">
            <div class="inline">
              <input
                type="number"
                :id="`index-${item.meterType}`"
                :name="`index-${item.meterType}`"
                class="input unit kwh"
                :class="{TA:isTestAchat}"
                :value="getActiveConsumptionValue(item)"
                @change="unvalidate();"
                @input="setActiveConsumptionValue(item, $event)"
                :placeholder="computeMeterPlaceholder(item)"
              />
              <span class="margin unit-text small" :class="{TA:isTestAchat}">{{ $t('kwh') }}</span>
            </div>
            <span v-if="checkConsumptionAmount(item)" class="input-error">{{ $t('validation.errors.highAmount', { max: '100000'}) }}</span>
            <span class="input-error">{{ errors[0] }}</span>
          </div>
          </ValidationProvider>
        </label>
      </div>
    </div>
    <EmptyHouse v-if="!knowConsumption"></EmptyHouse>
    <div v-if="!emptyHouse">
      <Inhabitant v-if="!knowConsumption"></Inhabitant>
      <HouseSize v-if="!knowConsumption"></HouseSize>
      <Occupation v-if="!knowConsumption"></Occupation>
      <HeaterType v-if="!knowConsumption"></HeaterType>
      <WaterType v-if="!knowConsumption"></WaterType>
      <HomeAppliance v-if="!knowConsumption && hasElec"></HomeAppliance>
      <Other v-if="!knowConsumption && hasElec" :show-battery="showBattery()"></Other>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import averageConsumption from "@/mixins/averageConsumption";
import EmptyHouse from "./EmptyHouse";
import Inhabitant from "./Inhabitant";
import HouseSize from "./HouseSize";
import HeaterType from "./HeaterType";
import WaterType from "./WaterType";
import HomeAppliance from "./HomeAppliance";
import Occupation from "./Occupation";
import Other from "./Other";
import SwitchField from "@/components/Form/SwitchField.vue";
import InputField from "../../../components/Form/InputField.vue";

export default {
  computed: {
    ...mapState("consumption", ["meterType", "consumptions", "emptyHouse", "solarPanelsScenario", "solarPanelsPower"]),
    ...mapGetters("consumption", ["activeConsumptions"]),
    ...mapGetters("common", ["isTestAchat"]),
    ...mapGetters("energy", ["hasElec", "hasGas"]),
    knowConsumption: {
      get() {
        return this.$store.state.consumption.knowConsumption;
      },
      set(value) {
        this.$store.commit("consumption/setKnowConsumption", value);
      }
    },
    knowNetConsumption: {
      get() {
        return this.$store.state.consumption.knowNetConsumption;
      },
      set(value) {
        this.recomputeActiveConsumptionValues(this.knowNetConsumption && !value);
        this.$store.commit("consumption/setKnowNetConsumption", value);
      }
    }
  },
  methods: {
    ...mapActions("consumption", ["recomputeActiveConsumptionValues"]),
    ...mapGetters("consumption", ["hasSolarPanels", "hasSmartMeter"]),
    average() {
      let consumption = averageConsumption();
      let consumptions = [
          {
            meterType: "day",
            value: consumption['day']
          },
          {
            meterType: "night",
            value: consumption['night']
          },
          {
            meterType: "mono",
            value: consumption['mono']
          },
          {
            meterType: "exclusiveNight",
            value: consumption['exclusiveNight']
          }
        ];

        if(this.hasSmartMeter && this.hasSolarPanels) {
          consumptions.push({
            meterType: "injectionDay",
            value: consumption['injectionBase']
          });
          consumptions.push({
            meterType: "injectionNight",
            value: consumption['injectionNight']
          });
        }

        if(this.hasGas) {
          consumptions.push({
            meterType: "gas",
            value: consumption['gas']
          });
        }

      this.$store.commit("consumption/setConsumptions", consumptions);
      this.$store.commit("consumption/setKnowConsumption", true);
    },
    unvalidate() {
      this.$store.commit("comparison/reset");
      this.$store.commit("consumption/setValid", false);
    },
    checkConsumptionAmount(item) {
      if(item.meterType === 'day' ||
         item.meterType === 'night' ||
         item.meterType === 'exclusiveNight' ||
         item.meterType === 'mono') {
        if(item.value > 100000) {
          return true
        }
      }
      else if(item.meterType === 'gas'){
        if(item.value > 100000) {
          return true
        }
      }
      else if(item.meterType === 'injectionDay' ||
         item.meterType === 'injectionBase' ||
         item.meterType === 'injectionNight') {
         if(item.value > 100000) {
          return true
        }
      }
      return false
    },
    showBattery() {
      let zipCode =  this.$store.state.calculation.zipCode;
      return (this.hasElec)
        && ((1000 >= zipCode && zipCode <= 1299) || (1500 >= zipCode && zipCode <= 3999) || (8000 >= zipCode && zipCode <= 9999))
        && this.$store.state.consumption.hasSolarPanels
        && this.$store.state.consumption.doubleFlow;
    },
    getMeterTypeLabel(item) {
      if (this.solarPanelsScenario === 'COMM_OFFTAKE_AND_INJECTION') {
        if (this.knowNetConsumption) {
          return this.$t(`step2.consumption.knownNetConsumption.${item.meterType}`);
        } else {
          return this.$t(`step2.consumption.unknownNetConsumption.${item.meterType}`);
        }
      }
      if(this.solarPanelsScenario === 'COMPENSATED_OFFTAKE') {
          return this.$t(`step2.consumption.unknownNetConsumption.${item.meterType}`);
      }
      return this.$t(`step2.consumption.${item.meterType}`);
    },
    setActiveConsumptionValue(item, event) {
      if(!isNaN(parseInt(event.target.value))){
        item.value = parseInt(event.target.value)
        return;
      }
      item.value = event.target.value
    },
    getActiveConsumptionValue(item) {
      return item.value
    },
    computeMeterPlaceholder(item) {
      if (this.knowNetConsumption)
        switch (item.meterType) {
          case "injectionBase":
            return Math.round(this.solarPanelsPower * 1000 * 0.8 * 0.7);
            break;
          case "injectionDay":
            return Math.round(this.solarPanelsPower * 1000 * 0.8 * 0.7 * (5 / 7));
            break;
          case "injectionNight":
            return Math.round(this.solarPanelsPower * 1000 * 0.8 * 0.7 * (2 / 7));
            break;
        }
      else
        switch (item.meterType) {
          case "injectionBase":
            return Math.round(this.solarPanelsPower * 1000 * 0.8);
            break;
          case "injectionDay":
            return Math.round(this.solarPanelsPower * 1000 * 0.8 * (5 / 7));
            break;
          case "injectionNight":
            return Math.round(this.solarPanelsPower * 1000 * 0.8 * (2 / 7));
            break;
        }
    }
  },
  components: {
    EmptyHouse,
    Inhabitant,
    HouseSize,
    HeaterType,
    WaterType,
    HomeAppliance,
    Occupation,
    Other,
    SwitchField,
    InputField
}
};
</script>

<style lang="scss">
.button.average {
  all:unset;
  font-size: 14px;
  text-decoration: underline $yellow;
  font-weight: bold;

  &:hover {
    cursor: pointer;
  }

  &.TA {
    text-decoration: underline;
    color: $pink;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/consumption/KnowConsumption/index.vue